import { gql } from "@apollo/client";
import { AddressInfoFragment } from "graphql/Address/fragments";

export const ReceiverInfoFragment = gql`
  fragment ReceiverInfo on Receiver {
    receiver_lastname
    receiver_firstname
    receiver_phone_number
    receiver_specification_address
    receiver_entreprise
    _id
    receiver_created_at
    receiver_last_edited_at
    receiver_address {
      ...AddressInfo
    }
  }
  ${AddressInfoFragment}
`;

